var map = {
	"./babel.mdx": [
		134,
		1
	],
	"./bots.mdx": [
		135,
		2
	],
	"./building-packages-for-runtimes.mdx": [
		136,
		3
	],
	"./bundle_size.mdx": [
		137,
		4
	],
	"./dependencies.mdx": [
		138,
		5
	],
	"./images.mdx": [
		139,
		6
	],
	"./importmaps-nodejs.mdx": [
		140,
		7
	],
	"./lerna.mdx": [
		141,
		8
	],
	"./linear-gradient-interpolation.mdx": [
		142,
		9
	],
	"./package.mdx": [
		143,
		10
	],
	"./payment.mdx": [
		144,
		11
	],
	"./remote.mdx": [
		146,
		12
	],
	"./web_past.mdx": [
		145,
		13
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 125;
module.exports = webpackAsyncContext;